(function () {
    const productOptions = document.querySelectorAll(".js-productSelectOption");
    const productSelectors = document.querySelectorAll(".js-productSelector");
    const productColour = document.querySelectorAll(".js-productColour");
    let i = 0;
    productSelectors.forEach(function (selector, idx) {
        selector.addEventListener("click", function () {
            productSelectors.forEach(function (s) {
                if (s === selector) {
                    s.classList.add("active");
                } else {
                    s.classList.remove("active");
                }
            });
            productOptions.forEach(function (option, j) {
                if (j === idx) {
                    option.classList.add("active");
                } else {
                    option.classList.remove("active");
                }
            });

            setProductColourName(this);
        });

        if (i === 0) {
            setProductColourName(selector);
        }

        i++;
    });

    function setProductColourName(el) {
        const name = el.dataset.name;

        if (name !== '' && productColour) {
            productColour.forEach(function (s) {
                s.innerHTML = name;
            });
        }
    }
})();
